/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_X_LinkInputs */

const ja_nav_x_link = /** @type {(inputs: Nav_X_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://x.com/PLAYBRAIN_ja`)
};

const en_nav_x_link = /** @type {(inputs: Nav_X_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://x.com/PLAYBRAIN_en`)
};

/**
* | output |
* | --- |
* | "https://x.com/PLAYBRAIN_en" |
*
* @param {Nav_X_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_x_link = /** @type {((inputs?: Nav_X_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_X_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_x_link(inputs)
	return en_nav_x_link(inputs)
});